import { useMutation } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { getBasketFromStorage, getRedirectState } from '../../utils/local-storage-versioning';
import { studentBookingClient } from '../../api';
import { BasketServiceEndpoints } from '../../api/basketService';
import { ErrorMessage } from '../../shared/enum/ErrorMessage';
import { routes } from '../../constants/routes';
import { buildSearchFromRedirectState } from '../../utils/build-redirect-search-params';
import { ErrorSnackbarContext } from '../../features/error-snackbar/error-snackbar-context';
import { ErrorSnackbarActionType } from '../../features/error-snackbar/types';

export const useCheckIsRebooker = () => {
    const storedBasket = getBasketFromStorage();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatchSnackbarError = useContext(ErrorSnackbarContext);

    return useMutation<void, AxiosError>({
        mutationKey: ['user', 'is-rebooker'],
        mutationFn: async () => {
            if (!storedBasket) throw new Error(ErrorMessage.NO_BASKET_ID);

            await studentBookingClient.get(
                BasketServiceEndpoints.CheckRebookerStatus.replace('{id}', storedBasket.id)
            );
        },
        onError(error) {
            if (error.message !== ErrorMessage.REBOOKER_STATUS_CHANGED) {
                navigate(routes.failure.index);
                return;
            }

            if (!location.pathname.includes(routes.yourDetails.index)) return;

            const redirectState = getRedirectState();
            const search = buildSearchFromRedirectState(redirectState);

            dispatchSnackbarError({
                type: ErrorSnackbarActionType.REBOOKER_PRICE_CHANGED,
                payload: null,
            });
            navigate({ pathname: routes.summary.index, search: search ? `?${search}` : '' });
        },
    });
};
